import type React from "react";

import type { QuestionDto, ResponseDto } from "@/api/types";
import { List } from "@/components/List/List";
import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import { MultiLineContent } from "@/components/MultiLineContent/MultiLineContent";
import { User } from "@/components/User/User";
import { Stack } from "@/design-system/Stack";

type SurveyOpenQuestionDetailsModalProps = ModalBaseProps & {
  question: QuestionDto;
  responses: ResponseDto[];
};

export function SurveyOpenQuestionDetailsModal({
  question,
  responses,
  isOpened,
  onOpenChange,
}: SurveyOpenQuestionDetailsModalProps): React.ReactNode {
  return (
    <Modal.Root
      title={question.question}
      description={question.description && <MultiLineContent>{question.description}</MultiLineContent>}
      {...{ isOpened, onOpenChange }}
    >
      <Modal.Body>
        <article className="grid grid-cols-1 gap-y-2">
          <List getKey={(user) => user.id} items={responses}>
            {(response) => {
              if (!response.text) {
                return null;
              }

              return (
                <Stack gap="sm" as="article">
                  <User user={response.respondent} />
                  <p>{response.text}</p>
                </Stack>
              );
            }}
          </List>
        </article>
      </Modal.Body>
    </Modal.Root>
  );
}
